/* eslint-disable import/prefer-default-export */
import { TRACKING_KEY, TRACKING_EVENT, TRACKING_VALUE } from 'shared/constants';

export const trackGeographicalInvestment = (tracking, geographical) => {
  const filterGeography = (listOfGeography) => {
    let value = '';
    if (listOfGeography.includes('askGeographically.convo.quick_replies.2')) {
      value += `${TRACKING_VALUE.EMERGING_MARKET}=Emerging markets;`;
    }
    if (listOfGeography.includes('askGeographically.convo.quick_replies.3')) {
      value += `${TRACKING_VALUE.KUWAIT_GCC}=Kuwait / GCC countries;`;
    }
    if (listOfGeography.includes('askGeographically.convo.quick_replies.4')) {
      value += `${TRACKING_VALUE.DEVELOPED_MARKET}=Developed markets (incl. USA);`;
    }
    if (listOfGeography.includes('askGeographically.convo.quick_replies.1')) {
      value = `${TRACKING_VALUE.GLOBAL}=All;`;
    }
    return value;
  };
  const body = {
    event: TRACKING_EVENT.SELECT,
    key: TRACKING_KEY.GEOGRAPHICAL_INVESTMENT,
    value: filterGeography(geographical),
    index: true,
    complex: true,
  };
  tracking.trackEvent(body);
};

export const trackRegulatoryInvestor = (tracking, value) => {
  const body = {
    event: TRACKING_EVENT.SELECT,
    key: TRACKING_KEY.REGULATORY_INVESTOR,
    value,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};

export const trackIslamicInvestor = (tracking, value) => {
  const body = {
    event: TRACKING_EVENT.SELECT,
    key: TRACKING_KEY.ISLAMIC_INVESTOR,
    value,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};
